import { FinantialSettingsPayoutScheduleService } from '@modules/subproperty-settings/finantial-settings/finantial-settings-payout-schedule/finantial-settings-payout-schedule-service';
import { i18n } from '@shared/i18n';
import Message from '@shared/message/message';
import Errors from '@shared/error/errors';

export default {
  namespaced: true,

  state: {
    loading: false,
    settings: null,
    connectedAccountId: null,
    stripeConnectedAccountId: null,
    globalErrorMessage: null,
    fieldErrors: {},
  },

  getters: {
    loading: state => state.loading,
    settings: state => state.settings,
    connectedAccountId: state => state.connectedAccountId,
    stripeConnectedAccountId: state => state.stripeConnectedAccountId,
    globalErrorMessage: (state) => state.globalErrorMessage,
    fieldErrors: (state) => state.fieldErrors,
  },

  mutations: {
    FETCH_STARTED(state) {
      state.loading = true;
      state.settings = null;
    },

    FETCH_SUCCESS(state, {settings, connectedAccountId, stripeConnectedAccountId}) {
      state.loading = false;
      state.settings = settings;
      state.connectedAccountId = connectedAccountId;
      state.stripeConnectedAccountId = stripeConnectedAccountId;
    },

    FETCH_ERROR(state) {
      state.loading = false;
      state.settings = null;
    },

    UPDATE_STARTED(state) {
      state.loading = true;
      state.settings = null;
      state.globalErrorMessage = null;
      state.fieldErrors = {};
    },

    UPDATE_SUCCESS(state) {
      state.loading = false;
      state.globalErrorMessage = null;
    },

    SET_ERROR(state, { errorMessage, errors }) {
      state.loading = false;

      state.globalErrorMessage = null;
      state.fieldErrors = [];

      state.globalErrorMessage = errorMessage;
      state.fieldErrors = errors;
    },
  },

  actions: {
    async doFetch({ commit }, { subpropertyId }) {
      try {
        commit('FETCH_STARTED');
        const result = await FinantialSettingsPayoutScheduleService.settings({ subpropertyId })
        if (!result) return

        const { settings, id, stripeConnectedAccountId } = result
        commit('FETCH_SUCCESS', {
          settings,
          connectedAccountId: id,
          stripeConnectedAccountId: stripeConnectedAccountId,
        });
      } catch (error) {
        Errors.handle(error);
        commit('FETCH_ERROR');
      }
    },

    async doUpdate({ commit, dispatch, rootGetters }, { propertyId, connectedAccountId, stripeConnectedAccountId, values }) {
      try {
        
        commit('UPDATE_STARTED');
        await FinantialSettingsPayoutScheduleService.update(propertyId, connectedAccountId, stripeConnectedAccountId, values);

        commit('UPDATE_SUCCESS');
        Message.success(i18n('subpropertySettings.finantial.payoutSchedule.update.success'));

        const currentManage = rootGetters['auth/manage/currentManage'];
        await dispatch('subproperty/requirements/doFetch', {
          propertyId: currentManage.property.id,
          subpropertyId: currentManage.subproperty.id,
          userId: rootGetters['auth/currentUser'].id
        }, {
          root: true
        });
      } catch (error) {
        Errors.handle(error, (errorMessage, errors) => {
          commit('SET_ERROR', { errorMessage, errors });
        });
      }
    },
  },
};
